import { ButtonText } from '@morressier/alembic';
import HighlightItem from '../editorial/PeerReview/HighlightItem';
import { useReviewData } from '../../../../contexts/ReviewDataProvider';
import { RATING_OPTIONS, SCORE_MAP } from '../../../../utils/reviews';
import { ReviewDetailsTab, REVIEW_DETAILS_TAB } from '../../../../pages/Review';
import {
  faClock,
  faStar,
  faTriangleExclamation
} from '@fortawesome/pro-regular-svg-icons';
import { IPeerReviewWFState } from '@publishing-engine/domain/types/workflow-phases';

interface Props {
  setActiveTab?: (tab: ReviewDetailsTab) => void;
}

export const ReviewScoreHighlight = ({ setActiveTab }: Props) => {
  const { review, submissionContext } = useReviewData();
  const reviewScore = review.caseData.firstAssessment?.reviewScore;
  const currentWFState = review.workflow.currentState as IPeerReviewWFState;

  // Review has been rescinded
  if (
    review.caseData.firstAssessmentRescission &&
    currentWFState === 'rescinded'
  ) {
    return (
      <HighlightItem
        icon={faTriangleExclamation}
        heading="Review Rescinded"
        variant="attention"
        customButton={
          <ButtonText
            flexShrink="0"
            onClick={() => setActiveTab?.(REVIEW_DETAILS_TAB.REVIEW)}
          >
            View Feedback
          </ButtonText>
        }
      />
    );
  }

  // Reviewer rating is not enabled for this journal
  if (!submissionContext?.config?.reviewerRating) {
    return null;
  }

  // Review not yet scored
  if (!reviewScore) {
    return (
      <HighlightItem
        icon={faClock}
        heading="Review Not Yet Scored"
        context="Your Review Score will be available upon manuscript decision."
        variant="attention"
      />
    );
  }

  const ratingOption = Object.values(RATING_OPTIONS).find(
    option => option.label.toLowerCase() === reviewScore.score
  );
  const scoreNumber = Object.values(SCORE_MAP).find(
    option => option.valueNumber === ratingOption?.value
  );

  const heading = `Review Scored as ${scoreNumber?.text}`;

  const handleViewFeedback = () => {
    setActiveTab?.(REVIEW_DETAILS_TAB.REVIEW);
  };

  return (
    <HighlightItem
      icon={faStar}
      heading={heading}
      context={reviewScore.justification}
      variant="attention"
      customButton={
        <ButtonText flexShrink="0" onClick={handleViewFeedback}>
          View Feedback
        </ButtonText>
      }
    />
  );
};
